import {config} from "@/constants/config";
import type {TResponseRequest} from "@/interfaces/http.interface";
import httpRequest from "@/providers/http/request.http";

export type PinStatus = "none" | "active" | "blocked";

export interface WalletPinInfo {
  walletId: string;
  pinStatus: PinStatus;
  pinFailedCount: number;
  pinBlockedAt: string | null;
}

export const getWalletPinStatusService = async (walletId: string): Promise<TResponseRequest<WalletPinInfo>> => {
  return httpRequest.get<WalletPinInfo>({
    url: `${config.walletApiUrl}/bo/wallets/${encodeURIComponent(walletId)}/pin`,
  });
};

export const resetWalletPinService = async (walletId: string): Promise<TResponseRequest<void>> => {
  return httpRequest.post<void>({
    url: `${config.walletApiUrl}/bo/wallets/${encodeURIComponent(walletId)}/pin/reset`,
    body: {},
  });
};

export const deleteWalletPinService = async (walletId: string): Promise<TResponseRequest<void>> => {
  return httpRequest.delete<void>({
    url: `${config.walletApiUrl}/bo/wallets/${encodeURIComponent(walletId)}/pin`,
    body: {},
  });
};
